export type RewardTaskType =
  | 'google_preferred_source'
  | 'share_x'
  | 'share_reddit'
  | 'share_linkedin'
  | 'share_facebook'
  | 'share_pinterest'
  | 'review_ios'
  | 'review_android'
  | 'review_chrome'
  | 'review_chatgpt'
  | 'review_trustpilot';

export type RewardSubmissionStatus = 'pending' | 'approved' | 'rejected';

/** @deprecated Kept for older submissions that used the combined mobile task. */
export type MobileStore = 'appstore' | 'playstore';

export interface ReviewSubmission {
  submission_id: string;
  user_id: string;
  task_type: RewardTaskType;
  status: RewardSubmissionStatus;
  screenshot_s3_key?: string;
  screenshot_url?: string;
  reward_credits: number;
  created_at: string;
  reviewed_at?: string;
  reviewed_by?: string;
  review_notes?: string;
  proof_url?: string;
  /** @deprecated Older mobile submissions only. */
  mobile_store?: MobileStore;
}

/**
 * Credit amounts per task. Keep in sync with the backend submit-review lambda.
 * Most tasks grant 1 credit; Google preferred source grants 2, and the hero
 * Trustpilot 5-star review grants 5 to drive high-value reviews.
 */
export const TASK_REWARD_CREDITS: Record<RewardTaskType, number> = {
  google_preferred_source: 2,
  share_x: 1,
  share_reddit: 1,
  share_linkedin: 1,
  share_facebook: 1,
  share_pinterest: 1,
  review_ios: 1,
  review_android: 1,
  review_chrome: 1,
  review_chatgpt: 1,
  review_trustpilot: 5,
};
